<template>
  <div :ref="element.paypal" class="tw:!mt-4" />
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { usePaypal } from '~/composables/usePayment'
import { axios } from '~/composables/general'
import { type PaymentInvoice } from './PaymentSectionPartial.vue'

const element = {
  paypal: ref<HTMLDivElement>()
}

const { invoice } = defineProps<{
  invoice: PaymentInvoice
}>()

const emit = defineEmits<{ success: [] }>()

onMounted(async () => {
  const paypal = await usePaypal()

  const btn = paypal.Buttons!({
    style: {
      shape: "rect",
      layout: "vertical",
      color: "gold",
      label: "paypal",
    },
    async createOrder() {
      const { data } = await axios.post<{ id: string }>(`/ticket/onward/invoice/${invoice._id}/paypal`)

      return data.id
    },

    async onApprove({ orderID }) {
      await axios.post<{ invoice: string }>(`/ticket/onward/invoice/${invoice._id}/paypal/capture`, {
        order_id: orderID
      })

      emit('success')
    }
  })

  btn.render(element.paypal.value!)
})
</script>